import { ThemeUICSSObject } from '@apia/theme';
import processes from './processes';
import reschedule from './reschedule';
import rollback from './rollback';
/* IMPORT HERE */

const control: ThemeUICSSObject = {
  processes,
  reschedule,
  rollback,
  /* PREPEND HERE */
};

export default control;
